// Sleep management routes
import SleepView from '../../views/SleepView.vue'
import EditSleepItemView from '../../views/EditSleepItemView.vue'
import CloudflareMediaView from '../../views/CloudflareMediaView.vue'

export default [
  {
    path: '/sleep',
    name: 'Sleep',
    component: SleepView,
    meta: { 
      requiresAuth: true,
      title: 'Sleep Mode'
    }
  },
  {
    path: '/sleep/:id/edit',
    name: 'EditSleepItem',
    component: EditSleepItemView,
    meta: { 
      requiresAuth: true,
      title: 'Edit Sleep Content'
    }
  },
  {
    path: '/sleep/create',
    name: 'CreateSleepItem',
    component: EditSleepItemView,
    meta: { 
      requiresAuth: true,
      title: 'Create Sleep Content'
    }
  },
  {
    path: '/sleep/media',
    name: 'CloudflareMedia',
    component: CloudflareMediaView,
    meta: { 
      requiresAuth: true,
      title: 'Cloudflare Media Gallery'
    }
  }
] 